export enum Theme {
  Light,
  Dark
}